import React from 'react';

import {
    TEST_STATUS__PASS,
    TEST_STATUS__FAIL,
    TEST_STATUS__INCOMPLETE,
    TEST_STATUS_FILTER_VALUE__PASS,
    TEST_STATUS_FILTER_VALUE__FAIL,
    TEST_STATUS_FILTER_VALUE__INCOMPLETE
} from '@shared/constants/constants';

const testStatusMap = {
    [TEST_STATUS__PASS]: TEST_STATUS_FILTER_VALUE__PASS.toUpperCase(),
    [TEST_STATUS__FAIL]: TEST_STATUS_FILTER_VALUE__FAIL.toUpperCase(),
    [TEST_STATUS__INCOMPLETE]: TEST_STATUS_FILTER_VALUE__INCOMPLETE.toUpperCase()
};

export default function TestStatusBadge({ testStatus, inline = false }) {
    const testStatusLabel = testStatusMap[testStatus];
    const className = testStatus === TEST_STATUS__FAIL ? 'fail' : 'pass';

    const Tag = inline ? 'span' : 'div';

    return <Tag className={className}>{testStatusLabel}</Tag>;
}
